/**
 * API'den gelen veriyi UI-friendly formata dönüştürür
 */
export const transformNewsData = (apiData) => {
  if (!apiData || !Array.isArray(apiData)) return [];
  
  return apiData.map(item => ({
    id: item.url, // Benzersiz ID olarak kullan
    slug: item.url,
    title: item.properties?.Title || item.title,
    image: item.properties?.ImageUrl || '',
    date: item.properties?.Date || item.createdAt,
    sourceUrl: item.properties?.Url || '',
    createdAt: item.createdAt,
    
    // Kaynak bilgisi URL'den çıkarılabilir
    source: extractSourceFromUrl(item.properties?.Url || ''),
    
    // Kategori bilgisi (API'den geliyorsa)
    category: item._category || '',
    
    // Okuma süresi tahmini (başlık uzunluğuna göre basit hesaplama)
    readTime: estimateReadTime(item.properties?.Title || ''),
    
    // Relative time (örn: "2 saat önce")
    relativeTime: getRelativeTime(item.properties?.Date || item.createdAt)
  }));
};

/**
 * URL'den kaynak site adını çıkarır
 */
export const extractSourceFromUrl = (url) => {
  if (!url) return 'Kaynak';
  
  try {
    const domain = new URL(url).hostname;
    // www. ve .com.tr gibi kısımları temizle
    const sourceName = domain.replace('www.', '').split('.')[0];
    return sourceName.charAt(0).toUpperCase() + sourceName.slice(1);
  } catch {
    return 'Kaynak';
  }
};

/**
 * Basit okuma süresi tahmini
 */
export const estimateReadTime = (title) => {
  if (!title) return 1;
  // Ortalama okuma hızı: 200 kelime/dakika
  // Başlık + tahmini içerik
  const estimatedWords = title.split(' ').length * 50; // Başlık kelime sayısı x 50
  return Math.max(1, Math.ceil(estimatedWords / 200));
};

/**
 * Relative time hesaplama (örn: "2 saat önce")
 */
export const getRelativeTime = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);

  if (diffInSeconds < 0) return 'Az önce';
  if (diffInSeconds < 60) return 'Az önce';
  if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} dakika önce`;
  if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} saat önce`;
  if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)} gün önce`;
  
  // 1 haftadan eski ise tam tarih göster
  return date.toLocaleDateString('tr-TR', { 
    day: 'numeric', 
    month: 'long', 
    year: 'numeric' 
  });
};

/**
 * Tarih formatla
 */
export const formatDate = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  return date.toLocaleDateString('tr-TR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};
